import React from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import BlogView from "./BlogView";

export default function PastBlogsModal({ show, onHide, blogs, loading }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      fullscreen="lg-down"
      centered
      scrollable
      enforceFocus={false}
      aria-labelledby="all-blogs-modal-title"
      contentClassName="past-blogs-modal-content"
      dialogClassName="past-blogs-modal-dialog"
    >
      <Modal.Header closeButton className="border-secondary bg-dark text-white">
        <Modal.Title id="all-blogs-modal-title" as="h2" className="h5 mb-0">
          All Posts
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="bg-dark p-0 p-sm-2"
        style={{ minHeight: "min(70vh, 600px)", maxHeight: "85vh" }}
      >
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center py-5"
            style={{ minHeight: "40vh" }}
          >
            <Spinner animation="border" role="status" variant="light">
              <span className="visually-hidden">Loading postings…</span>
            </Spinner>
          </div>
        ) : blogs && blogs.length > 0 ? (
          <BlogView blogs={blogs} />
        ) : (
          <p className="text-white-50 text-center py-5 mb-0 px-3">
            No postings to show.
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
}
